export default {
	modules:{
		auth: require('./auth').default,
		payment: require('./payment').default,
		report: require('./report').default,
		reconcialation: require('./reconcialation').default,
		member: require('./member').default,
		system: require('./system').default,
		coop: require('./coop').default,
		zipcode: require('./zipcode').default,
		
		productAndServices: require('./productAndServices.js').default,
		clients: require('./clients').default,
		cms: require('./cms').default,
		dashboard: require('./dashboard').default,
		accountant: require('./accountant').default,
		permission: require('./permission').default,
		reportUsers: require('./reportUsers.js').default,
		loanApplications: require('./loanApplications.js').default,
		utility: require('./utility.js').default,
		admin: require('./admin').default,
	}
}